import { createClient } from '@supabase/supabase-js';

//.env file
const supabaseURL = "https://kcrtuzvxxhettraujbwz.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtjcnR1enZ4eGhldHRyYXVqYnd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2Nzc0MzI4NjMsImV4cCI6MTk5MzAwODg2M30.FbxF0I_YV12iyvSNrUlSxmYRgHWJ2kc6wDsbjDgDsBM";

export const supabase = createClient(supabaseURL, supabaseAnonKey)